import React, { Component } from 'react';

class BecaFamilia3Table extends Component {
    state = {
        nomTmp: "",
        textI: "",
        nomTmpE: "",
        textE: "",
    }

    cambiaValor = (prop, tipo) => (e) => {
        if (e.target.value === "") return null

        if (tipo === "in"){
            this.props.funcion(prop, e.target.value, tipo)
        }else{ 
            this.props.funcion(prop, e.target.value, tipo)
        }
    }

    cambiaValorD = () => (e) => {
        if (e.target.value === "") return null
        if (this.state.nomTmp === "") return null

        this.props.funcion(this.state.nomTmp, e.target.value, "in")
    }

    cambiaState = (prop1, prop2) => (e) => {
        this.setState({
            [prop1]: (e.target.value).toUpperCase(),
            [prop2]: ""
        })
    }

    cambiaStateText = (prop) => (e) => {
        if (!isNaN(Number(e.target.value)) === false) return null;

        this.setState({
            [prop]: (e.target.value).toUpperCase(),
        })
    }

    cambiaStateOtroE = () => (e) => {
        this.setState({
            nomTmpE: (e.target.value).toUpperCase(),
            textE: ""
        })
     }

    render() {
        const { datos, egreso } = this.props;
        let { textI, textE } = this.state;
        const styles = {
            padding: 5, fontSize: 12
        }

        let contenidoI = (nombre, text) => {
            switch (true){
                case (nombre !== "" && text === true) : return nombre
                case (nombre !== "" && text === false) : return nombre
                case (nombre === "" && text === false) : return <input type="text" onChange={this.cambiaState("nomTmp", "textI")} className="form-control" placeholder="Tipo de Ingreso"/>
                default: return null
            }
        }

        let valorI = (nombre, text) => {
            switch (true){
                case (nombre !== "" && text === true) : return <input type="text" value={textI} onChange={this.cambiaStateText("textI")} onBlur={this.cambiaValor(nombre, "in")} className="form-control" placeholder="Bs."/>
                case (nombre !== "" && text === false) : return null
                case (nombre === "" && text === false) : return <input type="text" value={textI} onChange={this.cambiaStateText("textI")} onBlur={this.cambiaValorD()} className="form-control" placeholder="Bs."/>
                default: return null
            }
        }

        let contenidoE = (nombre, text) => {
            switch (true){
                case (nombre !== "" && text === true) : return nombre
                case (nombre !== "" && text === false) : return (
                    <React.Fragment>
                        {nombre}
                        <input type="text" onChange={this.cambiaStateOtroE()} className="form-control" placeholder="Tipo de Egreso"/>
                    </React.Fragment>
                )
                case (nombre === "" && text === false) : return <input type="text" onChange={this.cambiaStateOtroE()} className="form-control" placeholder="Tipo de Egreso"/>
                default: return null
            }
        }

        let valorE = (nombre, text) => {
            switch (true){
                case (nombre !== "" && text === true) : return <input type="text" value={textE} onChange={this.cambiaStateText("textE")} onBlur={this.cambiaValor(nombre, "out")} className="form-control" placeholder="Bs."/>
                case (nombre !== "" && text === false) : return <input type="text" value={textE} onChange={this.cambiaStateText("textE")} onBlur={this.cambiaValor(this.state.nomTmpE, "out")} className="form-control" placeholder="Bs."/>
                case (nombre === "" && text === false) : return <input type="text" value={textE} onChange={this.cambiaStateText("textE")} onBlur={this.cambiaValor(this.state.nomTmpE, "out")} className="form-control" placeholder="Bs."/>
                default: return null
            }
        }

        return (
            <tr>
                <td style={styles}>{contenidoI(datos.nombre, datos.text)}</td>
                <td style={styles} width="200px">{valorI(datos.nombre, datos.text)}</td>
                <td style={styles}>{contenidoE(egreso.nombre, egreso.text)}</td>
                <td style={styles} width="200px">{valorE(egreso.nombre, egreso.text)}</td>
                <td align="center" style={styles}></td>
            </tr>
        );
    }
}
 
export default BecaFamilia3Table;


// WEBPACK FOOTER //
// ./src/views/EstSolicitudes/BecaFamilia3Table.jsx